import { render, staticRenderFns } from "./home-join.vue?vue&type=template&id=2b466aac"
import script from "./home-join.vue?vue&type=script&lang=js"
export * from "./home-join.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports